import { render, staticRenderFns } from "./Responsibility.vue?vue&type=template&id=d9a12d10&scoped=true"
import script from "./Responsibility.vue?vue&type=script&lang=js"
export * from "./Responsibility.vue?vue&type=script&lang=js"
import style0 from "./Responsibility.vue?vue&type=style&index=0&id=d9a12d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a12d10",
  null
  
)

export default component.exports